import { defineNuxtPlugin } from '#app';
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

export default defineNuxtPlugin(async () => {
    const firebaseConfigs = {
      dev: {
        apiKey: "AIzaSyBffTHMv2BBR4hTDxi8sYwZRjnyQCPlJN8",
        authDomain: "divissa-dev.firebaseapp.com",
        projectId: "divissa-dev",
        storageBucket: "divissa-dev.firebasestorage.app",
        messagingSenderId: "84229456309",
        appId: "1:84229456309:web:f44f08d479276bf2e719fc",
        measurementId: "G-0NZ5KL779X",
      },
      staging: {
        apiKey: "AIzaSyBrgZQnKCE81lYZZ8gh2BO7qLsEU2Rk-1k",
        authDomain: "divissa-preprod.firebaseapp.com",
        projectId: "divissa-preprod",
        storageBucket: "divissa-preprod.firebasestorage.app",
        messagingSenderId: "525410782021",
        appId: "1:525410782021:web:fe0299626e8b74a5f54c2c",
        measurementId: "G-SH04B0VCQ8",
      },
      production: {
        apiKey: "AIzaSyCVuhz3NbOvkrAcGHDFfDL0jKR4sj92Vo8",
        authDomain: "divissa-3630e.firebaseapp.com",
        projectId: "divissa-3630e",
        storageBucket: "divissa-3630e.appspot.com",
        messagingSenderId: "404518901444",
        appId: "1:404518901444:web:a6701d6dc9b7f8bff91b91",
        measurementId: "G-5M9XBNXME7",
      },
    };
    const windowLocationOrigin = typeof window !== "undefined" && window.location.origin || 'https://www.divissa.com.tr';
    const getFirebaseConfig = () => {
        if (windowLocationOrigin.includes('localhost') || windowLocationOrigin.includes('devissa')) {
          return firebaseConfigs.dev;
        } else if (windowLocationOrigin.includes('previssa.com')) {
          return firebaseConfigs.staging;
        } else if (windowLocationOrigin.includes('divissa.com.tr')) {
          return firebaseConfigs.production;
        }
        return firebaseConfigs.dev;
      };
    const firebaseConfig = getFirebaseConfig();
    const app = initializeApp(firebaseConfig);

    const auth = getAuth(app);

    let analytics = null;
    if (await isSupported()) {
        analytics = getAnalytics(app);
    }

    return {
        provide: {
            firebase: {
                app,
                auth,
                analytics,
            },
        },
    };
});
